"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutObjectAclOutput = {
    type: "structure",
    required: [],
    members: {
        RequestCharged: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-request-charged"
        }
    }
};
//# sourceMappingURL=PutObjectAclOutput.js.map